module.exports = __webpack_public_path__ + "img/pfood.e5644dd9.jpg";